var exports = {
  "N": "x93eb46d8--625a52--card",
};

module.exports = exports;
